import { CREATE_DMX_DEVICE_PRESET, CREATE_DMX_DEVICE_PRESET_SUCCESSFUL, CREATE_DMX_DEVICE_PRESET_FAILED } from './actionTypes';

export const createDmxDevicePreset = (preset) => {
  return {
    type: CREATE_DMX_DEVICE_PRESET,
    payload: { preset },
  };
};

export const createDmxDevicePresetSuccessful = (message) => {
  return {
    type: CREATE_DMX_DEVICE_PRESET_SUCCESSFUL,
    payload: message,
  };
};

export const createDmxDevicePresetFailed = (message) => {
  return {
    type: CREATE_DMX_DEVICE_PRESET_FAILED,
    payload: message,
  };
};
